import { Employee } from '../../models';
import { GET_EMPLOYEES_LIST, RESET_EMPLOYEES_LIST } from '../constants/employeesList';

// eslint-disable-next-line import/prefer-default-export
export const getEmployeesList = (data) => {
  const { employees } = data;
  if (!employees) {
    return (dispatch) => {
      dispatch({ type: RESET_EMPLOYEES_LIST });
    };
  }

  const convertedEmployees = employees.map((item) => {
    /* eslint-disable-next-line camelcase */
    const { profile, active, is_owner } = item;
    const { id, email, name, surname, slug, phone, bio, image } = profile;
    return new Employee(id, email, name, surname, slug, phone, bio, image, is_owner, active);
  });

  return {
    type: GET_EMPLOYEES_LIST,
    payload: convertedEmployees,
  };
};
